import { Stack, Typography, Box, Divider } from "@mui/material";
import { Upload, Download, Close } from "@mui/icons-material";
import { convertBitsToBytes } from "../../../../../../utils/easyMaps/convertToBytes";

const MetricRow = ({
  txValue,
  txUnit,
  rxValue,
  rxUnit,
  txColor,
  rxColor,
  styles,
}) => (
  <Stack style={styles.layerRow}>
    <Box style={styles.metricContainer}>
      <Upload style={{ ...styles.icon, color: txColor ?? styles.icon.color }} />
      <Typography style={styles.fontPopup}>{txValue ?? "N/A"}</Typography>
      <Typography style={{ ...styles.fontPopup, ...styles.colorTextLayer }}>
        {txUnit}
      </Typography>
    </Box>
    <Divider orientation="vertical" flexItem style={styles.divider} />
    <Box style={styles.metricContainer}>
      <Download
        style={{ ...styles.icon, color: rxColor ?? styles.icon.color }}
      />
      <Typography style={styles.fontPopup}>{rxValue ?? "N/A"}</Typography>
      <Typography style={{ ...styles.fontPopup, ...styles.colorTextLayer }}>
        {rxUnit}
      </Typography>
    </Box>
  </Stack>
);

const PopupContent = ({
  variant,
  connectionData,
  host,
  theme,
  connectionConfig,
}) => {
  const interfaceName =
    connectionConfig?.interfaceName &&
    connectionConfig?.interfaceName?.trim() !== ""
      ? connectionConfig?.interfaceName
      : connectionData?.interface || "Desconhecido";

  const styles = {
    fontPopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    colorTextLayer: {
      color: theme.palette.text.disabled,
      fontWeight: 600,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.text.primary,
      width: "100%",
      textAlign: "center",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
    },
    layerRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      marginTop: "4px",
    },
    metricContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "2px",
    },
    divider: {
      height: "14px",
      alignSelf: "center",
    },
    icon: {
      fontSize: "14px",
      color: theme.palette.color.textEasyMaps,
    },
    stackPopup: {
      width: "170px",
    },
  };

  if (connectionData && connectionData.isDown) {
    return (
      <Stack
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          ...styles.stackPopup,
        }}
      >
        <Typography style={styles.titlePopup}>{host}</Typography>
        <Typography style={styles.titlePopup}>{interfaceName}</Typography>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            gap: 1,
            color: theme.palette.error.main,
          }}
        >
          <Close fontSize="medium" />
          <Typography
            style={{
              fontWeight: 700,
              fontSize: 12,
            }}
          >
            Offline
          </Typography>
        </Box>
      </Stack>
    );
  }
  if (variant === "trafego") {
    const outPutTrafficData = convertBitsToBytes(connectionData?.tx_traffic);
    const inPutTrafficData = convertBitsToBytes(connectionData?.rx_traffic);

    return (
      <Stack style={styles.stackPopup}>
        <Typography style={styles.titlePopup}>{host}</Typography>
        <Typography style={styles.titlePopup}>{interfaceName}</Typography>
        <MetricRow
          txValue={outPutTrafficData.valor}
          txUnit={outPutTrafficData.unidade}
          rxValue={inPutTrafficData.valor}
          rxUnit={inPutTrafficData.unidade}
          txColor={connectionData?.corTrafficTx?.cor}
          rxColor={connectionData?.corTrafficRx?.cor}
          styles={styles}
        />
      </Stack>
    );
  }

  if (variant === "potencia") {
    const txPower = connectionData?.tx_power;
    const rxPower = connectionData?.rx_power;

    return (
      <Stack style={styles.stackPopup}>
        <Typography style={styles.titlePopup}>{host}</Typography>
        <Typography style={styles.titlePopup}>{interfaceName}</Typography>
        <MetricRow
          txValue={typeof txPower === "number" ? txPower.toFixed(2) : txPower}
          txUnit="dBm"
          rxValue={typeof rxPower === "number" ? rxPower.toFixed(2) : rxPower}
          rxUnit="dBm"
          txColor={connectionData?.corPowerTx?.cor}
          rxColor={connectionData?.corPowerRx?.cor}
          styles={styles}
        />
      </Stack>
    );
  }

  return null;
};

export default PopupContent;
